﻿import controller from '../../../../Resources/Scripts/_Shared/controller';
import { appendContent, openOverlay } from '../../_Shared/Scripts/LandlordPermitOverlay'

function landlordStartPage(context) {
  const htmlElement = document.querySelector('html');
  const overlayContext = context.querySelector("[data-controller=landlord-permit-overlay]");

  function init() {
    context.addEventListener('click', async function (event) {
      if (event.target.dataset.createPermit) {
        event.preventDefault();

        const heading = event.target.dataset.heading;

        //Open create permit overlay
        openOverlay(overlayContext, { heading, hideLoader: true });
      } else if (event.target.dataset.editPermit) {
        event.preventDefault();

        const heading = event.target.dataset.heading;
        const permitId = event.target.dataset.permitId;

        //Open create permit overlay
        openOverlay(overlayContext, { heading, permitId, hideLoader: true });
      }
    });

    //openOverlay(overlayContext, { heading: 'Add new permit', hideLoader: true });
  }

  return {
    init
  };
}

controller.add('landlord-start-page', landlordStartPage);